import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../components/Carousel';

import '../styles/home.css'


function HomePage (props) {

  return (
    <div className="home-container">

      {/* <div className="home-info">
        <h1>David Beale</h1>
        <div className="home-title">Full Stack Developer</div>
        <div className="home-items">Javascript | HTML | CSS | NodeJS | React | Express | MongoDB | GraphQL </div>
      </div> */}

    </div>
  );

}

export default HomePage;